/**
 * Console twin of the product's `#/shared/lib/auth` surface.
 *
 * The product's store carries the signed-in tenant user; the console signs in
 * a platform admin who exists outside every tenant, so `user` is null. The
 * vendored hooks already handle a null user (they fall back to "no me row" /
 * "not the assignee"), which is exactly right for an admin acting on a
 * tenant's data.
 */
import type { UserResponse } from '#/shared/api/generated/auth/models'

interface AuthState {
  user: UserResponse | null
  permissions: string[] | null
}

const ADMIN_STATE: AuthState = { user: null, permissions: null }

export function useAuthStore<T>(selector: (state: AuthState) => T): T {
  return selector(ADMIN_STATE)
}
